import {fetch} from "utils/dataAccess";

export function error(error) {
    return {type: "GENDER_DELETE_SELECTION_ERROR", error};
}

export function loading(loading) {
    return {type: "GENDER_DELETE_SELECTION_LOADING", loading};
}

export function success(deleted) {
    return {type: "GENDER_DELETE_SELECTION_SUCCESS", deleted};
}

export function deleteSelection(genders) {
    return dispatch => {
        dispatch(loading(true));

        return fetch('/genders/delete_selection', {method: "POST", body: JSON.stringify({genders: genders})})
            .then(() => {
                dispatch(loading(false));
                dispatch(success(genders));
            })
            .catch((e) => {
                dispatch(loading(false));
                dispatch(error(e.message));
            });
    };
}